import { trackInitialGoogleAdsConversion } from '../../../../../services/googleAdsConversion.js';
import cn from 'classnames';
import styles from './PaymentMethodCard.module.scss';
import { Image } from '../../../../../components/Image/Image';
import { useEffect, useState } from 'react';
import { ExpressCheckoutElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router';
import { Spinner } from '../../../../../components/Spinner/Spinner';
import { ampPurchase, ampPurchaseStatus } from '../../../../../utils/AmplitudeEvents';
import { fbInitiateCheckout } from '../../../../../utils/FacebookEvents';
import { getSavedUtm } from '../../../../../services/utmHelpers.js'
import { getReferpulseAttribution } from '../../../../../services/referpulseAttribution.js';
import { trackGoogleAdsCheckoutStart } from '../../../../../utils/GoogleAdsFunnelEvents';
export const PaymentMethodGooglePay =({ data:planInfo,email,currency, method, status, onClick, onAvailable })=>{
  const [isAvailable, setIsAvailable] =useState(true);
  const [message, setMessage] =useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  useEffect(() => {
    if (isAvailable && onAvailable) {
      onAvailable();
    }
  }, [isAvailable, onAvailable]);

  const  {name, icon, list, securedText} = method;


  if (!stripe || !elements) return;
  const handleReady = ({ availablePaymentMethods }) => {
    console.log('availablePaymentMethods:',availablePaymentMethods)
    if (availablePaymentMethods && availablePaymentMethods?.googlePay) {
      setIsAvailable(true);
    } else {
      setIsAvailable(false);
    }
  };
const handleConfirm = async () => {
    trackGoogleAdsCheckoutStart();
    // setLoading(true);
    const {priceID,periodDays,oneTimePriceID} = planInfo;
    // console.log('data:',planInfo)
    const utm = getSavedUtm();
    const referpulse = getReferpulseAttribution();
    ampPurchaseStatus('started');
    const response = await fetch('/api/create-button-subscription.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        priceID,
        oneTimePriceID,
        periodDays,
        currency,
        utm,
        referpulse,
        plan: planInfo.title || ''
      }),
    });
    const data = await response.json();
    // console.log('dataRes:',data)
    if (data.error) {
      setMessage(data.error)
      ampPurchaseStatus('decline',data.error);
      setLoading(false);
      return;
    }
    if (!data.clientSecret || data.paymentIntentStatus == 'succeeded') return
    const { error,paymentIntent } = await stripe.confirmPayment({
      elements,
      clientSecret:data.clientSecret,
      confirmParams: {
        return_url: 'https://example.com/order/123/complete',
      },
      redirect: 'if_required',
    });

    if (error) {
      setMessage(error);
      ampPurchaseStatus('decline',error);
      setLoading(false);
      return
    } 
    if (paymentIntent?.status !== 'succeeded') {
      setMessage('Payment is not confirmed yet. Please contact support before retrying.');
      return;
    }
    const setPaymentData  = await fetch('/api/set-default-payment-method.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        payment_intent_id: paymentIntent.id,
        customerID: data.customerID,
        priceID,
        periodDays,
        currency,
        utm,
        referpulse,
        plan: planInfo.title || ''
      }),
    });
    const paymentData = await setPaymentData.json();
    if (paymentData.success !== true) {
      setMessage(paymentData.error || 'Payment could not be verified. Please contact support.');
      setLoading(false);
      return;
    }
    trackInitialGoogleAdsConversion(paymentData);
    ampPurchaseStatus('complete');
    localStorage.setItem('planInfo', JSON.stringify(planInfo));
    ampPurchase({currency, payment_method: 'GooglePay', price: data.salePrice/100, productId: data.priceID, quantity: 1});
    navigate(`/registration/?session_id=${paymentData.subscriptionId}`);
  };
  if(loading) return <Spinner/>
  if(!method || !planInfo || !isAvailable) return ;
  return(
    <div className={cn(
      styles.wrapper,
      status ==='open' && styles.open
      )}
      onClick={isAvailable ? onClick : undefined}
      tabIndex={isAvailable ? 0 : -1}
      aria-disabled={!isAvailable}
      >
      <div className={styles.header}>
        <div className={styles.bullet}></div>
        {name && <div className={styles.methodName}>{name}</div>}
        {icon && <Image src={icon} className={styles.icon}/>}
      </div>
      <div className={styles.content}>
        {list && 
          <div className={styles.listWrapper}>
            <ul className={styles.list}>
              {list.map((item,index)=>{
                return <li key={index} className={styles.item}>{item}</li>
              })}
            </ul>
          </div>
        }
        {/* paymentElements */}
        <div className={styles.paymentElements}>
          {status === 'open' &&
            <ExpressCheckoutElement
              options={{
                paymentMethods: {
                  amazonPay: 'never',
                  applePay: 'never',
                  googlePay: 'always',
                  link: 'never',
                  paypal: 'never'
                },
                buttonTheme: {
                  googlePay: 'black',
                },
                buttonType: {
                  googlePay: 'pay'
                },
              }}
              onReady={handleReady}
              onClick={(event) => {
                trackGoogleAdsCheckoutStart();
                event.resolve();
                fbInitiateCheckout();
                // console.log('click');
              }}
              onConfirm={handleConfirm}
            />
          }
          
        </div>
        {/* paymentElements */}
        {message && <div className={styles.message}>{typeof message === 'string' ? message : message.message}</div>}
        {securedText && <div className={styles.securedText}>{securedText}</div>}
      </div>
      
    </div>
  )
}
